import { MainFormState } from '../../../types/forms/form.def';

export const isValid = (errors: MainFormState<any>['errors']): boolean =>
  Object.values(errors).every(error => error === false);
